export const openPrintWindow = (htmlContent) => {
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  if (!printWindow) {
    // Fallback: render in current page
    const printDiv = document.createElement('div');
    printDiv.innerHTML = htmlContent;
    printDiv.style.position = 'fixed';
    printDiv.style.top = '0';
    printDiv.style.left = '0';
    printDiv.style.width = '100%';
    printDiv.style.height = '100%';
    printDiv.style.zIndex = '99999';
    printDiv.style.backgroundColor = 'white';
    printDiv.style.overflow = 'visible';
    document.body.appendChild(printDiv);
    setTimeout(() => {
      window.print();
      document.body.removeChild(printDiv);
    }, 250);
    return;
  }

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Print</title>
        <style>
          @page {
            size: A4;
            margin: 15mm 12mm 20mm 12mm;
          }
          
          @media print {
            html, body {
              margin: 0;
              padding: 0;
              font-family: 'Segoe UI', Arial, sans-serif;
              font-size: 11px;
              line-height: 1.4;
              color: #1F2937;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .print-page {
              page-break-after: always;
              page-break-inside: avoid;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 8px;
              font-size: 10px;
            }
            
            th {
              background-color: #F3F4F6 !important;
              color: #374151 !important;
              font-weight: 600;
              text-align: left;
              padding: 6px 8px;
              border: 1px solid #D1D5DB;
              font-size: 9px;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
            
            td {
              padding: 5px 8px;
              border: 1px solid #D1D5DB;
              vertical-align: top;
            }
            
            thead {
              display: table-header-group;
            }
            
            tbody {
              display: table-row-group;
            }
            
            tr {
              page-break-inside: avoid;
            }
            
            .no-break {
              page-break-inside: avoid;
            }
            
            .header-section {
              text-align: center;
              border-bottom: 2px solid #2563EB;
              padding-bottom: 12px;
              margin-bottom: 16px;
            }
            
            .header-section .logo {
              max-height: 60px;
              margin-bottom: 8px;
              object-fit: contain;
            }
            
            .header-section h1 {
              font-size: 18px;
              font-weight: 700;
              color: #1F2937;
              margin: 4px 0;
            }
            
            .header-section .company-info {
              font-size: 9px;
              color: #6B7280;
              margin: 2px 0;
            }
            
            .header-section .report-title {
              font-size: 14px;
              font-weight: 700;
              color: #2563EB;
              margin: 8px 0 4px 0;
            }
            
            .header-section .report-meta {
              font-size: 9px;
              color: #6B7280;
              margin: 2px 0;
            }
            
            .info-section {
              border: 1px solid #E5E7EB;
              border-radius: 4px;
              padding: 10px 12px;
              margin-bottom: 12px;
            }
            
            .info-section h3 {
              font-size: 10px;
              font-weight: 600;
              color: #374151;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              margin: 0 0 8px 0;
              padding-bottom: 4px;
              border-bottom: 1px solid #E5E7EB;
            }
            
            .info-grid {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 4px 16px;
            }
            
            .info-grid .info-item {
              display: flex;
              flex-direction: column;
            }
            
            .info-grid .info-item .label {
              font-size: 8px;
              color: #6B7280;
              text-transform: uppercase;
              letter-spacing: 0.3px;
            }
            
            .info-grid .info-item .value {
              font-size: 11px;
              font-weight: 600;
              color: #1F2937;
            }
            
            .earnings-table td:last-child,
            .deductions-table td:last-child {
              text-align: right;
              font-weight: 600;
            }
            
            .total-row {
              background-color: #EFF6FF !important;
              font-weight: 700;
            }
            
            .total-row td {
              font-size: 11px;
              color: #2563EB;
            }
            
            .deductions-total-row {
              background-color: #FEF2F2 !important;
              font-weight: 700;
            }
            
            .deductions-total-row td {
              color: #EF4444;
            }
            
            .net-pay-section {
              background: linear-gradient(135deg, #2563EB, #1D4ED8) !important;
              border-radius: 6px;
              padding: 12px 16px;
              margin-bottom: 12px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            
            .net-pay-section .net-label {
              color: rgba(255,255,255,0.85);
              font-size: 10px;
            }
            
            .net-pay-section .net-amount {
              color: white;
              font-size: 18px;
              font-weight: 700;
            }
            
            .net-pay-section .net-sub {
              color: rgba(255,255,255,0.7);
              font-size: 10px;
              text-align: right;
            }
            
            .signature-section {
              margin-top: 20px;
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 20px;
            }
            
            .signature-box {
              border-top: 1px solid #374151;
              padding-top: 6px;
              margin-top: 30px;
            }
            
            .signature-box .sig-label {
              font-size: 9px;
              color: #6B7280;
              margin-bottom: 2px;
            }
            
            .footer-note {
              text-align: center;
              font-size: 8px;
              color: #9CA3AF;
              border-top: 1px solid #E5E7EB;
              padding-top: 8px;
              margin-top: 16px;
            }
            
            .page-number-container {
              text-align: center;
              font-size: 8px;
              color: #9CA3AF;
              padding: 4px 0;
            }
            
            .status-badge-print {
              display: inline-block;
              padding: 2px 8px;
              border-radius: 10px;
              font-size: 9px;
              font-weight: 600;
              border: 1px solid;
            }
            
            .status-approved {
              background-color: #DCFCE7 !important;
              color: #166534;
              border-color: #86EFAC;
            }
            
            .status-pending {
              background-color: #FEF9C3 !important;
              color: #854D0E;
              border-color: #FDE047;
            }
            
            .status-rejected {
              background-color: #FEE2E2 !important;
              color: #991B1B;
              border-color: #FCA5A5;
            }
            
            .leave-detail-labels {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 8px;
              margin-bottom: 10px;
            }
            
            .leave-label-item {
              display: flex;
              flex-direction: column;
            }
            
            .leave-label-item .lbl {
              font-size: 8px;
              color: #6B7280;
              text-transform: uppercase;
            }
            
            .leave-label-item .val {
              font-size: 12px;
              font-weight: 600;
              color: #1F2937;
            }
            
            .approval-letter-body {
              margin: 20px 0;
              line-height: 1.8;
            }
            
            .approval-letter-body p {
              margin: 8px 0;
              font-size: 11px;
            }
            
            @media screen {
              body {
                padding: 20px;
              }
            }
        </style>
      </head>
      <body>
        ${htmlContent}
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 500);
            }, 300);
          };
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
};

export const formatCurrency = (v) => {
  return `KES ${Number(v || 0).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatDate = (v) => {
  if (!v) return '';
  try {
    return new Date(v).toLocaleDateString('en-KE', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } catch {
    return v;
  }
};

export const generatePayslipHTML = (companyInfo, staff, payroll) => {
  const today = new Date().toLocaleDateString('en-KE', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });

  return `
    <div class="header-section">
      ${companyInfo.logo ? `<img src="${companyInfo.logo}" alt="Logo" class="logo" onerror="this.style.display='none'" />` : ''}
      <h1>${companyInfo.name || 'NutriAxis Clinic'}</h1>
      <div class="company-info">${companyInfo.address || 'Nairobi, Kenya'}</div>
      ${companyInfo.phone ? `<div class="company-info">Tel: ${companyInfo.phone}</div>` : ''}
      ${companyInfo.email ? `<div class="company-info">Email: ${companyInfo.email}</div>` : ''}
      ${companyInfo.pin ? `<div class="company-info">KRA PIN: ${companyInfo.pin}</div>` : ''}
      <div class="report-title">PAYSLIP</div>
      <div class="report-meta">Pay Period: ${formatDate(payroll.pay_date)} | Generated: ${today}</div>
    </div>

    <div class="info-section no-break">
      <h3>Employee Details</h3>
      <div class="info-grid">
        <div class="info-item">
          <span class="label">Employee Name</span>
          <span class="value">${staff.full_name || ''}</span>
        </div>
        <div class="info-item">
          <span class="label">Employee ID</span>
          <span class="value">${staff.staff_id || ''}</span>
        </div>
        <div class="info-item">
          <span class="label">Department</span>
          <span class="value">${staff.department || ''}</span>
        </div>
        <div class="info-item">
          <span class="label">Position</span>
          <span class="value">${staff.position || ''}</span>
        </div>
        <div class="info-item">
          <span class="label">Employment Type</span>
          <span class="value">${staff.employment_type || ''}</span>
        </div>
        <div class="info-item">
          <span class="label">Payment Method</span>
          <span class="value">${payroll.payment_method || 'Bank Transfer'}</span>
        </div>
      </div>
    </div>

    <div class="no-break">
      <div class="info-section">
        <h3>Earnings</h3>
        <table class="earnings-table">
          <thead>
            <tr>
              <th style="width:70%">Description</th>
              <th style="width:30%;text-align:right">Amount (KES)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Basic Salary</td>
              <td>${formatCurrency(payroll.salary)}</td>
            </tr>
            ${Number(payroll.allowances) > 0 ? `<tr><td>Allowances</td><td>${formatCurrency(payroll.allowances)}</td></tr>` : ''}
            ${Number(payroll.bonuses) > 0 ? `<tr><td>Bonuses</td><td>${formatCurrency(payroll.bonuses)}</td></tr>` : ''}
            <tr class="total-row">
              <td>Gross Pay</td>
              <td>${formatCurrency(payroll.gross_pay)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="info-section">
        <h3>Deductions</h3>
        <table class="deductions-table">
          <thead>
            <tr>
              <th style="width:70%">Description</th>
              <th style="width:30%;text-align:right">Amount (KES)</th>
            </tr>
          </thead>
          <tbody>
            ${Number(payroll.nhif) > 0 ? `<tr><td>NHIF</td><td>${formatCurrency(payroll.nhif)}</td></tr>` : ''}
            ${Number(payroll.nssf) > 0 ? `<tr><td>NSSF</td><td>${formatCurrency(payroll.nssf)}</td></tr>` : ''}
            ${Number(payroll.paye) > 0 ? `<tr><td>PAYE</td><td>${formatCurrency(payroll.paye)}</td></tr>` : ''}
            ${Number(payroll.housing_levy) > 0 ? `<tr><td>Housing Levy</td><td>${formatCurrency(payroll.housing_levy)}</td></tr>` : ''}
            ${Number(payroll.advances) > 0 ? `<tr><td>Advances</td><td>${formatCurrency(payroll.advances)}</td></tr>` : ''}
            ${Number(payroll.loan_deductions) > 0 ? `<tr><td>Loan Deductions</td><td>${formatCurrency(payroll.loan_deductions)}</td></tr>` : ''}
            ${Number(payroll.deductions) > 0 ? `<tr><td>Other Deductions</td><td>${formatCurrency(payroll.deductions)}</td></tr>` : ''}
            ${Number(payroll.total_deductions) > 0 ? `<tr class="deductions-total-row"><td>Total Deductions</td><td>${formatCurrency(payroll.total_deductions)}</td></tr>` : ''}
          </tbody>
        </table>
      </div>
    </div>

    <div class="net-pay-section no-break">
      <div>
        <div class="net-label">Net Pay</div>
        <div class="net-amount">${formatCurrency(payroll.net_pay)}</div>
      </div>
      <div>
        <div class="net-sub">Amount Paid: ${formatCurrency(payroll.amount_paid)}</div>
        ${Number(payroll.balance_due) > 0 ? `<div class="net-sub">Balance Due: ${formatCurrency(payroll.balance_due)}</div>` : ''}
        <div class="net-sub">Payment Status: ${payroll.payment_status || 'Pending'}</div>
      </div>
    </div>

    <div class="signature-section no-break">
      <div class="signature-box">
        <div class="sig-label">Employee Signature</div>
        <div style="height:40px;"></div>
        <div class="sig-label">Date: _______________</div>
      </div>
      <div class="signature-box">
        <div class="sig-label">HR Manager / Authorized Signatory</div>
        <div style="height:40px;"></div>
        <div class="sig-label">Date: _______________</div>
      </div>
    </div>

    <div class="footer-note">
      <p>This is a computer-generated payslip and does not require a signature if printed electronically.</p>
      <p>Generated on ${today} | ${companyInfo.name || 'NutriAxis Clinic'}</p>
    </div>
  `;
};

export const generateLeaveDocumentHTML = (companyInfo, staff, leave) => {
  const today = new Date().toLocaleDateString('en-KE', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });

  const statusClass = leave.status === 'Approved' ? 'status-approved' : 
                      leave.status === 'Rejected' ? 'status-rejected' : 'status-pending';

  return `
    <div class="header-section" style="padding-bottom:8px;margin-bottom:10px;">
      ${companyInfo.logo ? `<img src="${companyInfo.logo}" alt="Logo" class="logo" style="max-height:45px;margin-bottom:4px;" onerror="this.style.display='none'" />` : ''}
      <h1 style="font-size:16px;margin:2px 0;">${companyInfo.name || 'NutriAxis Clinic'}</h1>
      <div class="company-info" style="font-size:8px;margin:1px 0;">${companyInfo.address || 'Nairobi, Kenya'}</div>
      ${companyInfo.phone ? `<div class="company-info" style="font-size:8px;margin:1px 0;">Tel: ${companyInfo.phone}</div>` : ''}
      ${companyInfo.email ? `<div class="company-info" style="font-size:8px;margin:1px 0;">Email: ${companyInfo.email}</div>` : ''}
      <div class="report-title" style="font-size:12px;margin:4px 0 2px 0;">LEAVE APPROVAL LETTER</div>
      <div class="report-meta" style="font-size:8px;margin:1px 0;">Date: ${today}</div>
    </div>

    <div class="approval-letter-body" style="margin:8px 0;line-height:1.5;">
      <p style="margin:3px 0;font-size:10px;"><strong>To:</strong> ${staff.full_name || ''}</p>
      <p style="margin:3px 0;font-size:10px;"><strong>Employee ID:</strong> ${staff.staff_id || ''} &nbsp;|&nbsp; <strong>Department:</strong> ${staff.department || ''} &nbsp;|&nbsp; <strong>Position:</strong> ${staff.position || ''}</p>
      <p style="margin:4px 0;font-size:10px;"><strong>RE: LEAVE APPLICATION - ${(leave.leave_type || '').toUpperCase()}</strong></p>
      <p style="margin:3px 0;font-size:10px;">Dear ${staff.full_name ? staff.full_name.split(' ')[0] : 'Employee'},</p>
      <p style="margin:3px 0;font-size:10px;">This letter serves as official notification regarding your leave application submitted for <strong>${leave.leave_type || ''}</strong>.</p>
    </div>

    <div class="info-section no-break" style="padding:6px 10px;margin-bottom:8px;">
      <h3 style="font-size:9px;margin:0 0 4px 0;padding-bottom:2px;">Leave Details</h3>
      <div class="leave-detail-labels" style="display:grid;grid-template-columns:1fr 1fr;gap:2px 12px;margin-bottom:4px;">
        <div class="leave-label-item">
          <span class="lbl" style="font-size:7px;">Leave Type</span>
          <span class="val" style="font-size:10px;">${leave.leave_type || ''}</span>
        </div>
        <div class="leave-label-item">
          <span class="lbl" style="font-size:7px;">Duration</span>
          <span class="val" style="font-size:10px;">${leave.days_taken || 'N/A'} days</span>
        </div>
        <div class="leave-label-item">
          <span class="lbl" style="font-size:7px;">Start Date</span>
          <span class="val" style="font-size:10px;">${formatDate(leave.start_date)}</span>
        </div>
        <div class="leave-label-item">
          <span class="lbl" style="font-size:7px;">End Date</span>
          <span class="val" style="font-size:10px;">${formatDate(leave.end_date)}</span>
        </div>
      </div>
      ${leave.reason ? `
        <div style="margin-top:4px;padding-top:4px;border-top:1px solid #E5E7EB;">
          <span style="font-size:7px;color:#6B7280;text-transform:uppercase;">Reason</span>
          <div style="font-size:10px;font-weight:600;color:#1F2937;margin-top:1px;">${leave.reason}</div>
        </div>
      ` : ''}
    </div>

    <div class="info-section no-break" style="padding:6px 10px;margin-bottom:8px;">
      <h3 style="font-size:9px;margin:0 0 4px 0;padding-bottom:2px;">Approval Status</h3>
      <div style="display:flex;align-items:center;gap:6px;">
        <span class="status-badge-print ${statusClass}" style="padding:1px 6px;font-size:8px;">${leave.status || 'Pending'}</span>
        <span style="font-size:9px;color:#6B7280;">
          ${leave.status === 'Approved' ? 'Your leave has been approved as requested.' :
            leave.status === 'Rejected' ? 'Your leave application has been reviewed and declined.' :
            'Your leave application is pending review by management.'}
        </span>
      </div>
      ${leave.approved_by ? `
        <div style="margin-top:3px;font-size:8px;color:#6B7280;">
          Approved/Reviewed by: ${leave.approved_by}
        </div>
      ` : ''}
      ${leave.comments ? `
        <div style="margin-top:3px;font-size:8px;color:#6B7280;padding:4px 6px;background:#F9FAFB;border:1px solid #E5E7EB;border-radius:3px;">
          <strong>Comments:</strong> ${leave.comments}
        </div>
      ` : ''}
    </div>

    <div class="signature-section no-break" style="margin-top:12px;display:grid;grid-template-columns:1fr 1fr;gap:16px;">
      <div class="signature-box" style="border-top:1px solid #374151;padding-top:4px;margin-top:16px;">
        <div class="sig-label" style="font-size:8px;color:#6B7280;margin-bottom:1px;">Employee Signature</div>
        <div style="height:24px;"></div>
        <div class="sig-label" style="font-size:8px;color:#6B7280;">Date: _______________</div>
      </div>
      <div class="signature-box" style="border-top:1px solid #374151;padding-top:4px;margin-top:16px;">
        <div class="sig-label" style="font-size:8px;color:#6B7280;margin-bottom:1px;">HR Manager / Authorized Signatory</div>
        <div style="height:24px;"></div>
        <div class="sig-label" style="font-size:8px;color:#6B7280;">Date: _______________</div>
      </div>
    </div>

    <div class="footer-note" style="text-align:center;font-size:7px;color:#9CA3AF;border-top:1px solid #E5E7EB;padding-top:4px;margin-top:8px;">
      <p style="margin:1px 0;">This is an official leave document from ${companyInfo.name || 'NutriAxis Clinic'}.</p>
      <p style="margin:1px 0;">Generated on ${today} | Reference: ${leave.reference_no || `LEAVE-${leave.id || 'N/A'}`}</p>
    </div>
  `;
};
